import { Task } from '../../types';

interface SponsorsTask {
  id: number;
  type: string;
  view_details: {
    link: string;
    title: string;
  };
  details: Record<string, any>;
  target_progress: number;
  user_progress: number;
  rewards: {
    stars: number;
  };
  status: string;
}

interface SponsorsResponse {
  status: string;
  tasks: SponsorsTask[];
}

export enum SponsorsStatus {
  Active = 'active',
  Done = 'done',
  Claim = 'claim',
  Waiting = 'waiting',
}

const mapSponsorsStatusToTaskStatus = (
  status: SponsorsStatus,
): Task['status'] => {
  switch (status) {
    case SponsorsStatus.Active:
      return 'NOT_STARTED';
    case SponsorsStatus.Done:
      return 'CLAIMED';
    case SponsorsStatus.Claim:
      return 'DONE';
    case 'waiting':
      return 'IN_PROGRESS';
    default:
      return 'NOT_STARTED';
  }
};

export class SponsorsAdapter {
  static adaptTasks(response: SponsorsResponse): Task[] {
    if (!response.tasks) {
      console.warn('❌ No tasks in response:', response);
      return [];
    }

    console.log('fasfas', response);

    return response.tasks.map((task) => ({
      id: task.id,
      title: task.view_details.title,
      rewards: task.rewards,
      status: mapSponsorsStatusToTaskStatus(task.status as SponsorsStatus),
      progress: {
        current: task.user_progress,
        total: task.target_progress,
      },
      link: task.view_details.link,
      provider: 'SPONSORS',
      type: 'sponsor-subs',
      visibility: true,
      instructions: task.details.task_instructions,
      icon: task.details.photo,
    }));
  }
}
